<section class="login-page" *ngIf="!autenticado">
  <div class="login-card">
    <div class="login-brand">⚖️</div>
    <h1>PeritoDesk</h1>
    <p class="login-subtitle">Ambiente demo para apresentação em VPS.</p>

    <label>Usuário</label>
    <input [(ngModel)]="loginForm.usuario" autocomplete="username" placeholder="Usuário" />

    <label>Senha</label>
    <input [(ngModel)]="loginForm.senha" type="password" autocomplete="current-password" placeholder="Senha" (keyup.enter)="entrar()" />

    <div class="login-error" *ngIf="loginErro">{{ loginErro }}</div>

    <button class="login-primary" type="button" (click)="entrar()" [disabled]="loginCarregando">
      {{ loginCarregando ? 'Entrando...' : 'Entrar' }}
    </button>

    <button class="login-secondary" type="button" (click)="entrarComDemo()">
      Entrar como demonstração
    </button>

    <div class="demo-box">
      <strong>Usuários demo</strong>
    </div>
  </div>
</section>

<div class="app-shell" *ngIf="autenticado">
  <aside class="sidebar" [class.fechado]="!menuAberto">
    <div class="brand-row" [class.recuado]="!menuAberto" (click)="!menuAberto ? abrirMenuCompleto() : null" [attr.title]="!menuAberto ? 'Abrir menu completo' : null">
      <button class="toggle-btn" type="button" (click)="alternarMenu($event)" [attr.title]="menuAberto ? 'Recuar menu' : 'Abrir menu'">☰</button>
      <span class="brand-text" *ngIf="menuAberto && menuNivel === 'principal'">PeritoDesk</span>
      <span class="brand-text" *ngIf="menuAberto && menuNivel !== 'principal'">Menu</span>
      <span class="brand-compact" *ngIf="!menuAberto">PD</span>
    </div>

    <nav class="menu-list" *ngIf="!menuAberto || menuNivel === 'principal'">
      <a routerLink="/dashboard" routerLinkActive="ativo" class="has-tooltip" data-tooltip="Dashboard" (click)="recuarMenuAposNavegacao()">
        <span class="icon">📊</span>
        <span class="label" *ngIf="menuAberto">Dashboard</span>
      </a>

      <!-- v92.1.7: Perícia agora é um grupo fixo, com submenu sempre visível quando o menu está aberto. -->
      <div class="menu-section pericia-section">
        <button class="menu-action has-tooltip pericia-menu-principal" type="button" data-tooltip="Perícia" (click)="!menuAberto ? abrirMenuCompleto() : null">
          <span class="icon">📁</span>
          <span class="label" *ngIf="menuAberto">Perícia</span>
        </button>

        <div class="submenu-inline pericias-inline sempre-visivel" *ngIf="menuAberto">
          <a routerLink="/pericias" [queryParams]="{ aba: 'Perícia' }" class="submenu-link" (click)="recuarMenuAposNavegacao()">
            <span class="icon">📋</span>
            <span>
              <strong>Lista / Workspace</strong>
              <small>acesso normal às perícias</small>
            </span>
          </a>

          <a routerLink="/pericias" [queryParams]="{ aba: 'Fluxo Assistido' }" class="submenu-link destaque-bpmn" (click)="recuarMenuAposNavegacao()">
            <span class="icon">🔁</span>
            <span>
              <strong>Assistente de Perícia BPMN</strong>
              <small>fluxo visual orientado pela NBC</small>
            </span>
          </a>
        </div>
      </div>

      <a routerLink="/calendario" routerLinkActive="ativo" class="has-tooltip" data-tooltip="Calendário" (click)="recuarMenuAposNavegacao()">
        <span class="icon">📅</span>
        <span class="label" *ngIf="menuAberto">Calendário</span>
      </a>

      <a routerLink="/pendencias" routerLinkActive="ativo" class="has-tooltip" data-tooltip="Pendências" (click)="recuarMenuAposNavegacao()">
        <span class="icon">⚠️</span>
        <span class="label" *ngIf="menuAberto">Pendências</span>
      </a>

      <div class="menu-group" *ngFor="let grupo of gruposMenuSecundarios()">
        <button class="menu-action has-tooltip" type="button" [attr.data-tooltip]="grupo.titulo" (click)="abrirGrupoComoTela(grupo)">
          <span class="icon">{{ grupo.icone }}</span>
          <span class="label" *ngIf="menuAberto">{{ grupo.titulo }}</span>
          <span class="chevron" *ngIf="menuAberto">›</span>
        </button>
      </div>
    </nav>

    <nav class="menu-list menu-secundario" *ngIf="menuAberto && menuNivel === 'grupo' && grupoAtivo">
      <button class="menu-back" type="button" (click)="voltarMenuPrincipal()">
        <span>←</span>
        <span>Voltar ao menu principal</span>
      </button>

      <div class="menu-title-card">
        <span class="icon grande">{{ grupoAtivo.icone }}</span>
        <div>
          <strong>{{ grupoAtivo.titulo }}</strong>
          <small>Escolha uma opção</small>
        </div>
      </div>

      <button
        class="submenu-screen-action"
        type="button"
        *ngFor="let item of grupoAtivo.itens"
        (click)="abrirSubgrupoComoTela(item, $event)">
        <span class="icon">{{ item.icone }}</span>
        <span class="label">{{ item.label }}</span>
        <span class="chevron" *ngIf="item.filhos?.length">›</span>
      </button>
    </nav>

    <nav class="menu-list menu-secundario" *ngIf="menuAberto && menuNivel === 'subgrupo' && grupoAtivo && itemPaiAtivo">
      <button class="menu-back" type="button" (click)="voltarParaGrupo()">
        <span>←</span>
        <span>Voltar para {{ grupoAtivo.titulo }}</span>
      </button>

      <div class="menu-title-card">
        <span class="icon grande">{{ itemPaiAtivo.icone }}</span>
        <div>
          <strong>{{ itemPaiAtivo.label }}</strong>
          <small>{{ grupoAtivo.titulo }}</small>
        </div>
      </div>

      <button
        class="submenu-screen-action nivel-3-screen"
        type="button"
        *ngFor="let filho of itemPaiAtivo.filhos"
        (click)="navegarParaSubitem(filho)">
        <span class="icon">{{ filho.icone }}</span>
        <span class="label">{{ filho.label }}</span>
      </button>
    </nav>
    <div class="sidebar-user" *ngIf="menuAberto">
      <span>{{ sessao?.nome }}</span>
      <button type="button" (click)="sair()">Sair</button>
    </div>
  </aside>

  <main class="main-area">
    <router-outlet></router-outlet>
  </main>
</div>
